import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { first, map } from 'rxjs';
import { DeviceStatusService } from 'src/app/core/entities/device/device-status.service';
import { AuthService } from '../../services/auth/auth.service';

/**
 * Guard function to check if the user is logged in before navigating to a route.
 * Injects the authentication service and router to check the user's login status.
 * If the user is logged in, allows navigation by returning true.
 * If the user is not logged in, navigates to the login page and returns false.
 * @returns {Observable<boolean>} An observable indicating if navigation is allowed.
 */
export const isNotLoggedInGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const deviceStatus = inject(DeviceStatusService);

  return authService.isLoggedIn.pipe(
    first(),
    map((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        deviceStatus.checkDeviceStatus(false);

        return false;
      }

      return true;
    })
  );
};
